import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStrikethrough = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M2.25 10A.75.75 0 0 1 3 9.25h14a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
    <path d="M7.074 6.625c.378-1.115 1.812-1.863 3.49-1.875.805-.005 1.564.167 2.137.487.562.314.92.75 1.036 1.302a.75.75 0 0 0 1.467-.308c-.223-1.064-.916-1.826-1.772-2.304-.846-.472-1.873-.684-2.878-.677-1.94.014-4.219.88-4.9 2.895-.312.922-.293 1.74.06 2.432.34.67.934 1.102 1.525 1.395.212.105.434.197.658.278h5.04c-.606-.272-1.221-.471-1.715-.631L11 9.546a14 14 0 0 0-1.08-.284l-.478-.116c-.56-.14-1.095-.3-1.536-.519-.444-.22-.719-.463-.855-.73-.125-.246-.193-.63.024-1.272Zm7.938 5.125h-2.411q.106.053.208.11c.713.394 1.196.868 1.368 1.486.076.273.031.605-.138.92-.692 1.286-2.195 2-3.767 1.984-1.566-.017-2.99-.755-3.584-2.118a.75.75 0 1 0-1.376.598c.892 2.049 2.96 2.998 4.944 3.02 1.98.02 4.084-.876 5.104-2.774.316-.588.46-1.318.262-2.032a3.4 3.4 0 0 0-.61-1.194" />
  </svg>
);
export default SvgStrikethrough;
